import { connect } from 'react-redux';
import SummaryStepView from '../../../components/views/mx/creditoReal/SummaryStepView';
import * as WizardMXActions from '../../../actions/WizardMXActions';
import * as WizardActions from '../../../actions/WizardActions';
import * as ModalActions from '../../../actions/ModalActions';
import { withRouter } from 'react-router';
import * as LoginActions from '../../../actions/LoginActions';

function mapStateToProps(state, {match}) {
    const summary = state.creditoReal.loanApplication.summary || {};
    return {
        desiredVehicle: summary.desiredVehicle,
        price: summary.price,
        entry: summary.downPayment,
        state: summary.state,
        term: summary.term,
        amountFinance: summary.amountFinance,
        detailCommission: summary.detailCommission,
        monthlyPayment: summary.monthlyPayment,
        monthlyInsurance:summary.monthlyInsurance,
        completeName: summary.completeName,
        birthDate: summary.birthDate,
        rfc: summary.rfc,
        cellPhone: summary.cellPhone,
        email: summary.email,
        homeAddress: summary.homeAddress,
        homeExtNumber: summary.homeExtNumber,
        homeIntNumber: summary.homeIntNumber,
        homePostalCode: summary.homePostalCode,
        homeState: summary.homeState,
        homeCity: summary.homeCity,
        homeMunicipality: summary.homeMunicipality,
        homeColony: summary.homeColony,
        homePhone: summary.homePhone,
        workplaceName: summary.workplaceName,
        workplacePosition: summary.workplacePosition,
        workplaceSince : summary.workplaceSince,
        workplaceAddress: summary.workplaceAddress,
        workplaceExtNumber: summary.workplaceExtNumber,
        workplaceIntNumber: summary.workplaceIntNumber,
        workplacePostalCode: summary.workplacePostalCode,
        workplaceState: summary.workplaceState,
        workplaceCity: summary.workplaceCity,
        workplaceMunicipality: summary.workplaceMunicipality,
        workplaceColony: summary.workplaceColony,
        workplacePhone: summary.workplacePhone,
        workplacePhoneExt: summary.workplacePhoneExt,
        workplaceMonthlyIncomes: summary.workplaceMonthlyIncomes,
        insurancePaymentType: summary.insurancePaymentType,
        insuranceName: summary.insuranceName,
        insuranceAmount: summary.insuranceAmount,
        references: summary.references,
        token: match.params.token,
        steps: [
            {id: 'datos_solicitante', name: 'Datos del solicitante'},
            {id: 'domicilio_actual', name: 'Domicilio actual'},
            {id: 'autorizacion_privacidad_buro', name: 'Aviso de privacidad y Autorización de Buró'},
            {id: 'informacion_laboral', name: 'Información laboral'},
            {id: 'referencias', name: 'Referencias'},
            {id: 'seguros', name: 'Seguros'},
            {id: 'carga_archivos', name: 'Carga de archivos'},
            {id: 'resumen', name: 'Resumen'},
        ],
        name: summary.name
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getLoanApplicationSummary: token => () => {
            dispatch(WizardMXActions.GET_LOAN_APPLICATION_SUMMARY_MX_ACTION.action(token));
        },
        onPressStep: (stepId, token) => {
            dispatch(WizardActions.SET_LOAN_APPLICATION_TOKEN_ACTION.action(token));
            dispatch(WizardMXActions.SET_RETURN_TO_SUMMARY.action(stepId));
        },
        closeMarketingModal: () => {
            dispatch(ModalActions.CLOSE_MODAL_ACTION.action());
        },
        onPressGotoHome: () => {
            dispatch(WizardMXActions.CLEAN_STATE_ONCE_FINISHED_LOAN.action());
            dispatch(WizardMXActions.CLEAN_STATE_ONCE_FINISHED_LOAN_TURBO_CASH.action());
            dispatch(WizardMXActions.GO_TO_HOME_ACTION.action());
        }
    };
}

function mergeProps(stateProps, dispatchProps) {
    return {
        ...stateProps,
        ...dispatchProps,
        getLoanApplicationSummary: dispatchProps.getLoanApplicationSummary(stateProps.token),
        steps: stateProps.steps.map(item => ({
            ...item,
            onPress: () => dispatchProps.onPressStep(item.id)
        })),
    };
}

const SummaryStepContainer = withRouter<any, any>(connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(SummaryStepView));

export default SummaryStepContainer;